import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { AppSettings, AsamcoUserService } from '@asamco/base';
import { Group } from './../group/group.interface';
import { ServiceHelperService } from '@asamco/utils';
import { from, Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';

import { UserGroup } from './usergroup.interface';

/**
 *Service for usergroups
 *
 * @export
 */
@Injectable({
	providedIn: 'root',
	deps: [ServiceHelperService, HttpClient, AppSettings, AsamcoUserService],
})
export class UsergroupService {
	/**
	 *Database actions
	 */
	private dbActions = this.serviceHelper.createHelper<UserGroup>('usergroup');

	/**
	 *Get all usergroups
	 *
	 */
	getAll = this.dbActions.getAll;

	/**
	 *Get usergroup by id
	 *
	 */
	get = this.dbActions.get;

	/**
	 *Save usergroup
	 *
	 */
	save = this.dbActions.save;

	/**
	 *Delete usergroup
	 *
	 */
	delete = this.dbActions.delete;

	/**
	 *Creates an instance of UsergroupService.
	 * @param serviceHelper
	 * @param http
	 * @param appSettings
	 * @param asamcoUserService
	 */
	constructor(
		private serviceHelper: ServiceHelperService,
		private http: HttpClient,
		private appSettings: AppSettings,
		private asamcoUserService: AsamcoUserService
	) {}

	/**
	 * Gets the usergroups by the user id
	 * @param userId The id of the user
	 */
	public getByUserId(userId: number): Observable<UserGroup[]> {
		return this.getAll().pipe(map(data => data.filter(row => row.userId === userId)));
	}

	/**
	 *Removes user from group
	 *
	 * @param userId
	 * @param groupId
	 * @returns
	 */
	public removeUserFromGroup(userId: number, groupId: number) {
		return this.http.delete(`usergroup/user/${userId}/group/${groupId}`);
	}

	/**
	 * Updates the groups for an user
	 *
	 * @param userId The user id
	 * @param groupIds The ids of the new groups
	 */
	public updateGroupsForUser(userId: number, ...groupIds: number[]): Observable<Group[]> {
		const request: UpdateUserGroupsRequest = {
			userId,
			groups: groupIds,
		};

		return from(this.asamcoUserService.hasPermission('USER_GROUP_UPDATE_USER')).pipe(hasPermission => {
			if (hasPermission) {
				return this.http.post<Group[]>(`usergroup/user/update`, request);
			} else {
				// No permission, return empty observable
				return of([]);
			}
		});
	}
}

/**
 *Interface for update user group requests
 */
interface UpdateUserGroupsRequest {
	/**
	 *  ets or sets the user identifier.
	 */
	userId: number;
	/**
	 * Gets or sets the new groups.
	 */
	groups: number[];
}
